/* eslint-disable @next/next/no-img-element */
import { getCookie } from 'framework/libs/cookie';
import { TOKEN_CONGDONG } from 'framework/store/constants';
import isEmpty from 'lodash/isEmpty';
import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import http from "utilities/http";

export default function Index({ oldSelected = [], set }) {
    const [searchTag, setSearchTag] = useState('');
    const [tagsListDisplay, setTagsListDisplay] = useState([]);
    const [selectedTags, setSelectedTags] = useState(oldSelected);

    useEffect(() => {
        if (isEmpty(oldSelected)) return;
        setSelectedTags(oldSelected);
    }, [oldSelected]);
    const [show, setShow] = useState(false);

    const onAdd = (item) => {
        setSelectedTags(selectedTags.concat(item));
    };

    const onRemove = (item) => {
        setSelectedTags(selectedTags.filter(x => x.id != item.id));
    };

    const fetchTag = async () => {
        const url = `community/tag?per_page=20&q=` + searchTag;

        const response = await http(url, null, {}, 'v2');
        if (response.code == 200) {
            setTagsListDisplay(response.data);
        }
    };

    useEffect(() => {
        fetchTag();
    }, [searchTag]);

    useEffect(() => {
        set(selectedTags);
    }, [selectedTags]);

    const createNew = async () => {
        if (isEmpty(getCookie(TOKEN_CONGDONG))) toast.info('Bạn cần đăng nhập để thao tác');

        const url = `community/tag`;
        const response = await http(url, {},
            {
                method: 'POST',
                token: 'Bearer ' + getCookie(TOKEN_CONGDONG),
                body: { name: searchTag },
            },
            'v2');
        if (response.code == 200) {
            toast.info('Tạo mới hashtag thành công!');
            onAdd(response.data);
            setTagsListDisplay([response.data]);
            // setShow(false);
        }
    };

    const style = {
        position: 'absolute',
        willChange: 'transform',
        top: 0,
        left: 0,
        transform: 'translate3d(20px, -374px, 0px)',
    };
    return <div className="searchTag">
        <ul className="list-tag">
            {selectedTags.map((item, index) => {
                return <li key={index}>#{item.name}
                    <span className="closeTag" onClick={() => onRemove(item)}></span>
                </li>;
            })}
        </ul>

        <div className="createPost-tag">
            <span className="createPost-tag-other">#</span>
            <input className="form-control" placeholder="Tạo hashtag cho bài viết" data-toggle="dropdown"
                value={searchTag}
                onChange={(e) => setSearchTag(e.target.value)}
                onClick={() => setShow(true)}
            />

            <div className={"dropdown-menu dropdown-menu--tag " + (show ? 'show' : '')} style={style}>
                <div className="boxTag filterBox-mb">
                    <div className="headTab sp-only">
                        <h3 className="tlt">Chọn thẻ cho bài đăng</h3>
                        <span className="filter-close"><img src="/images/icon-close.png" alt="" onClick={() => setShow(false)}/></span>

                        <div className="search">
                            <button className="btn"><img src="/images/icon-search.svg" alt="" /></button>
                            <input className="form-control" type="text" placeholder="Tìm tên thẻ"
                                value={searchTag}
                                onChange={(e) => setSearchTag(e.target.value)}
                                onClick={() => setShow(true)} />
                        </div>

                        <ul className="list-tag">
                            {selectedTags.map((item, index) => {
                                return <li key={index}>#{item.name}
                                    <span className="closeTag" onClick={() => onRemove(item)}></span>
                                </li>;
                            })}
                        </ul>
                    </div>
                    <div className="lstTag">
                        <ul>
                            {tagsListDisplay.map((item, index) => {
                                const isSelected = selectedTags.find(x => x.id === item.id) ? 'active' : '';

                                return <li key={index} className={isSelected ? 'active' : ''} onClick={() => isSelected ? onRemove(item) : onAdd(item)}>
                                    <span className="lstTag-text">#{item.name}</span>
                                </li>;
                            })}
                        </ul>
                    </div>
                    <div className="btnTag">
                        {searchTag &&<button className="btn btn--blue" onClick={createNew}>Tạo hashtag mới: #{searchTag}</button>}
                        {!searchTag &&<button className="btn btn--blue">Nhập để tìm kiếm hoặc tạo hashtag mới</button>}
                    </div>
                </div>
            </div>
        </div>

        {show && <div className="backdrop" style={{position: 'fixed'}}
            onClick={() => setShow(false)}>
        </div>}
    </div>;
};